import React from 'react';
import { motion, useViewportScroll, useTransform } from "framer-motion";

function Quote() {
    const { scrollYProgress } = useViewportScroll();
    const scale = useTransform(scrollYProgress, [0, 1], [0.2, 1.6]);

    return(
       <div className="py-5 bg-scenery1 bg-fixed">
        <div className="min-w-screen bg-gray-200 flex items-center justify-center px-5 py-5">
        <motion.div
            className="container"
            style={{scale}}
        >
       
            <div className="sm:w-full lg:w-3/5 md:w-3/5 mx-auto rounded-lg bg-white shadow-lg my-20 px-5 pt-5 pb-10 text-gray-800">
                <div className="w-full mb-10">
                    <div className="text-xs text-gray-600 text-center px-5 font-poppins">
                    Dari Anas bin Malik radhiyallahu ‘anhu,  ia berkata bahwa Rasulullah shallallahu ‘alaihi wa sallam bersabda
                    </div>
                    <p className="text-sm text-gray-600 text-center px-5">
                        <div className="mb-5 mt-8">
                            إِذَا تَزَوَّجَ العَبْدُ فَقَدْ كَمَّلَ نَصْفَ الدِّيْنِ ، فَلْيَتَّقِ اللهَ فِي النِّصْفِ البَاقِي  
                        </div>
                        <div className="text-3xl text-indigo-500 text-left leading-tight h-3">“</div>
                        <div className="font-poppins">
                        Jika seseorang menikah, maka ia telah menyempurnakan separuh agamanya. Karenanya, bertakwalah pada Allah pada separuh yang lainnya.
                        </div>
                        <div className="text-3xl text-indigo-500 text-right leading-tight h-3 -mt-3">”</div>
                    </p>
                </div>
                <div className="w-full">
                    {/* <p className="text-md text-indigo-500 font-bold text-center">Scott Windon</p> */}
                    <p className="text-xs text-gray-500 text-center">(HR. Al Baihaqi dalam Syu’abul Iman. Dishahihkan oleh Syaikh Al Albani dalam As Silsilah Ash Shahihah no. 625)</p>
                </div>
            </div>
            <motion.div
            className="item"
            style={{
                scaleY: scrollYProgress
            }}/>
        </motion.div>
        </div>
       </div>
    );
}

export default Quote;